export const rugbyBundesligaNeuesJahr = {
  "id": "rugby-bundesliga-neues-jahr",
  "title": "Rugby-Bundesliga startet mit frischem Schwung ins neue Jahr",
  "slug": "rugby-bundesliga-frischer-schwung-neues-jahr",
  "publishedAt": "2026-01-05T09:00:00Z",
  "author": "Rugby-Bundesliga-Ausschuss",
  "language": "de",
  "readTime": "4 min",
  "tags": [
    "Rugby",
    "Bundesliga",
    "Rugby Deutschland",
    "RBA",
    "Nachwuchsförderung",
    "Ehrenamt"
  ],
  "excerpt": "Die Rugby-Bundesliga startet mit wichtigen organisatorischen Weichenstellungen, neuen Unterstützer*innen und Anträgen zur Weiterentwicklung der Ausbildungs- und Nachwuchsförderung ins neue Jahr.",
  "img": "/images/rugby-bundesliga-neues-jahr.jpg",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Zunächst möchten wir allen Beteiligten der Rugby-Bundesliga – Vereinen, Spielenden, Trainerinnen, Schiedsrichterinnen, Ehrenamtlichen und Unterstützenden – ein gesundes, erfolgreiches und sportlich faires neues Jahr wünschen. Gemeinsam wollen wir die Bundesliga weiterentwickeln, professionalisieren und nachhaltig stärken."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Ankündigung: RBA-Sitzung am 10. Januar um 13:00 Uhr"
    },
    {
      "type": "paragraph",
      "content": "Der Rugby-Bundesliga-Ausschuss (RBA) kommt am Samstag, den 10.01., ab 13:00 Uhr zu seiner nächsten Sitzung zusammen. Die Sitzung findet als Präsenzveranstaltung statt."
    },
    {
      "type": "paragraph",
      "content": "Auf der Tagesordnung stehen unter anderem:"
    },
    {
      "type": "list",
      "items": [
        "Begrüßung sowie Feststellung von Anwesenheit und Stimmberechtigung",
        "Wahl desder Protokollführerin und desder Versammlungsleiterin",
        "Tätigkeitsbericht des RBA",
        "Wahlen: des*der RBA-Vorsitzenden",
        "des*der stellvertretenden Vorsitzenden für den 15er-Spielbetrieb",
        "des*der stellvertretenden Vorsitzenden für den 7er-Spielbetrieb",
        "Beratung und Abstimmung über eingereichte Anträge",
        "Verschiedenes",
        "Festlegung von Datum und Ort der nächsten Sitzung"
      ]
    },
    {
      "type": "paragraph",
      "content": "Alle Bundesligavereine sind eingeladen, sich aktiv an der Sitzung und den anstehenden Entscheidungen zu beteiligen."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Kurzzusammenfassung der Anträge zur RBA-Sitzung"
    },
    {
      "type": "paragraph",
      "content": "Im Rahmen der Sitzung werden mehrere Anträge zur Weiterentwicklung der Bundesligarichtlinie beraten. Die wichtigsten Inhalte in Kürze:"
    },
    {
      "type": "heading",
      "level": 3,
      "content": "Umbenennung des „Scorebonus“ in „Ausbildungsbonus“"
    },
    {
      "type": "paragraph",
      "content": "Mit diesem Antrag erfolgt eine rein begriffliche Klarstellung. Die bisherige Bezeichnung „Scorebonus“ soll durch „Ausbildungsbonus“ ersetzt werden, um den tatsächlichen Zweck der Regelung – die Förderung von Nachwuchs- und Ausbildungsarbeit – eindeutiger darzustellen. Inhaltliche Änderungen ergeben sich aus den weiteren Anträgen, nicht aus der Umbenennung selbst."
    },
    {
      "type": "heading",
      "level": 3,
      "content": "Verpflichtende Dokumentation der Jugendlaufbahn ab Jahrgang 2012"
    },
    {
      "type": "paragraph",
      "content": "Für Spielende ab dem Geburtsjahrgang 2012 soll die Jugendlaufbahn ausschließlich über Jugend- und Spielerpässe dokumentiert werden. Übergangsregelungen durch Glaubhaftmachung entfallen für diese Jahrgänge. Ziel sind mehr Einheitlichkeit, Transparenz und Rechtssicherheit."
    },
    {
      "type": "heading",
      "level": 3,
      "content": "Bonus für langfristige Vereinszugehörigkeit und ehrenamtliches Engagement"
    },
    {
      "type": "paragraph",
      "content": "Vorgeschlagen werden zusätzliche Anreize für:"
    },
    {
      "type": "list",
      "items": [
        "Spielende mit mindestens sieben aufeinanderfolgenden Saisons im selben Verein",
        "aktive Jugendtrainer*innen mit entsprechender Lizenz und nachgewiesener Tätigkeit"
      ]
    },
    {
      "type": "paragraph",
      "content": "Ergänzend ist eine Deckelung der maximal möglichen Bonuspunkte vorgesehen, um die Balance des Systems zu erhalten."
    },
    {
      "type": "heading",
      "level": 3,
      "content": "Erweiterung des Ausbildungszeitraums"
    },
    {
      "type": "paragraph",
      "content": "Der relevante Zeitraum für die Anerkennung von Ausbildungsleistungen soll vom vollendeten 12. auf das vollendete 8. Lebensjahr ausgeweitet werden. Zusätzlich soll eine perspektivische Anerkennung möglich sein, wenn die erforderliche Ausbildungsdauer bis zum 21. Lebensjahr planbar erreicht wird."
    },
    {
      "type": "paragraph",
      "content": "Die Anträge verfolgen insgesamt das Ziel, Ausbildungsrealitäten besser abzubilden, nachhaltige Vereinsarbeit zu stärken und die Nachwuchs- sowie Ausbildungsförderung in der Rugby-Bundesliga weiterzuentwickeln."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Neue Unterstützer*innen für die Rugby-Bundesliga"
    },
    {
      "type": "heading",
      "level": 3,
      "content": "📺 Tobias Bleckmann – Livestreaming & Video"
    },
    {
      "type": "paragraph",
      "content": "Mit Tobias Bleckmann (📧 videoBL@rugbydeutschland.org) steht eine zentrale Ansprechperson für das Thema Bundesliga-Streaming zur Verfügung."
    },
    {
      "type": "paragraph",
      "content": "Ziel ist es, die Livestreams der Bundesligaspiele künftig gebündelt über den offiziellen YouTube-Kanal der Rugby-Bundesliga auszuspielen. Dadurch sollen Reichweite, Sichtbarkeit und ein einheitlicher, professioneller Außenauftritt der Liga gestärkt werden."
    },
    {
      "type": "paragraph",
      "content": "Im Zuge dessen wird eine Arbeitsgruppe „Video“ eingerichtet. Diese ist offen für Teilnehmende aus allen Bundesligavereinen, insbesondere für Personen mit Interesse oder Erfahrung im Bereich Streaming, Video-, Kamera- oder Übertragungstechnik. Interessierte können sich direkt und unkompliziert an Tobias Bleckmann wenden."
    },
    {
      "type": "heading",
      "level": 3,
      "content": "🏉 Björn Frommann – Trainersymposien & Wissenstransfer"
    },
    {
      "type": "paragraph",
      "content": "Mit Björn Frommann (📧 coachingbl@rugbydeutschland.org) wird der Bereich Trainersymposien für Bundesligacoaches weiterentwickelt und strukturell betreut."
    },
    {
      "type": "paragraph",
      "content": "Bereits zwei Trainersymposien haben stattgefunden, diese sollen nun intensiviert und regelmäßig fortgeführt werden. Ziele sind:"
    },
    {
      "type": "list",
      "items": [
        "fachlicher Austausch zwischen den Trainer*innen der Bundesligavereine",
        "Fort- und Weiterbildungsangebote",
        "Austausch und Vernetzung mit den Nationalmannschaften",
        "Förderung des Wissenstransfers innerhalb von Rugby Deutschland"
      ]
    },
    {
      "type": "paragraph",
      "content": "Damit soll vorhandenes Wissen besser gebündelt, geteilt und langfristig für die sportliche Entwicklung im gesamten Verband nutzbar gemacht werden."
    },
    {
      "type": "heading",
      "level": 3,
      "content": "📱 Social Media: Zentrale Kontaktadresse"
    },
    {
      "type": "paragraph",
      "content": "Für den Bereich Social Media steht weiterhin Paul Williams als Ansprechpartner zur Verfügung. Neu ist eine zentrale E-Mailadresse für Input, Inhalte und Kontaktaufnahmen: 📧 socialmediabl@rugbydeutschland.org"
    },
    {
      "type": "paragraph",
      "content": "Vereine sind ausdrücklich eingeladen, hier Spieltagsinformationen, besondere Aktionen oder mediale Inhalte einzureichen."
    },
    {
      "type": "paragraph",
      "content": "Der Rugby-Bundesliga-Ausschuss bedankt sich bei allen Engagierten für ihren Einsatz und freut sich auf ein konstruktives, sportlich erfolgreiches Rugby-Jahr. Gemeinsam gestalten wir die Zukunft der Rugby-Bundesliga."
    }
  ]
};
